module.exports = __webpack_public_path__ + "img/account-details-header.7239b6cc.png";